module.exports = __webpack_public_path__ + "50979c65efa79da655cd4fe6311c07ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/tesla_2021_chart.png
// module id = 1746
// module chunks = 0